'use client'

import { AppLayout } from '@/components/app-layout'

export default function AuthenticatedAppLayout({ children }: { children: React.ReactNode }) {
    // All routes in (app) group are authenticated
    // AppLayout handles the authenticated UI with sidebar, search, etc.
    return <AppLayout>{children}</AppLayout>
}
